// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__b-ffl","active":"Tabs_active__Efb0l"};